import {
  DONHANGSANPHAM_COUNT_ASSIGN_SUCCESS,
  DONHANGSANPHAM_HISTORY_LIST_SUCCESS,
  DONHANGSANPHAM_IMPORT_SUCCESS,
  DONHANGSANPHAM_LIST_SUCCESS,
  DONHANGSANPHAM_NEW_CARE_SUCCESS,
  DONHANGSANPHAM_ONE_SUCCESS,
  DONHANGSANPHAM_UPDATE_FILTER,
  DONHANGSANPHAM_SAVE_SUCCESS,
  DONHANGSANPHAM_UPDATE_HOMEPAGE_FILTER,
  DONHANGSANPHAM_HOMEPAGE_LIST_SUCCESS,
  DONHANGSANPHAM_HOMEPAGE_ONE_SUCCESS,
  DONHANGSANPHAM_LIMIT_UPDATE_HOMEPAGE_FILTER,
  DONHANGSANPHAM_LIMIT_HOMEPAGE_LIST_SUCCESS,
  DONHANGSANPHAM_LIMIT_HOMEPAGE_ONE_SUCCESS,
  DONHANGSANPHAM_HANDLE_IMPORT_ERRORS
} from 'src/actions/donhangsanpham.action';
import { LOOKUP_CLEANER } from 'src/actions/lookup.action';

import {
  DEFAULT_ROW_PER_PAGE,
} from 'src/utils/constants';

const initState = {
  filter: {
    so_dien_thoai: '',
    loai_sim: {},
    page: 0,
    limit: DEFAULT_ROW_PER_PAGE,
  },
  homepageDonhangsanphamFilter: {
    so_dien_thoai: '',
    loai_sim: {},
    homepageDonhangsanphamPage: 0,
    homepageDonhangsanphamLimit: DEFAULT_ROW_PER_PAGE,
  },
  homepageDonhangsanphamLimitFilter: {
    so_dien_thoai: '',
    loai_sim: {},
    homepageDonhangsanphamLimitPage: 0,
    homepageDonhangsanphamLimitLimit: DEFAULT_ROW_PER_PAGE,
  },
  items: [],
  total: 0,
  selected: undefined,
  homepageDonhangsanphamItems: [],
  homepageDonhangsanphamTotal: 0,
  homepageDonhangsanphamSelected: undefined,
  homepageDonhangsanphamLimitItems: [],
  homepageDonhangsanphamLimitTotal: 0,
  homepageDonhangsanphamLimitSelected: undefined,
  temp: [],
  countAssign: 0,
  history: [],
  totalHistory: 0,
  newCare: undefined,
  canCare: 0,
  temp_upgoicuoc: [],
  errorRows: {},
}

const donhangsanphamReducer = (state = initState, action) => {
  switch (action.type) {
    case DONHANGSANPHAM_UPDATE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.filter !== 'undefined' && state.filter) {
        if (action.data.page == 'no_update' && typeof state.filter.page !== 'undefined') action.data.page = state.filter.page;
        if (action.data.limit == 'no_update' && typeof state.filter.limit !== 'undefined') action.data.limit = state.filter.limit;
      }
      return {
        ...state,
        filter: action.data,
      }
    }
    case DONHANGSANPHAM_UPDATE_HOMEPAGE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.homepageDonhangsanphamFilter !== 'undefined' && state.homepageDonhangsanphamFilter) {
        if (action.data.homepageDonhangsanphamPage == 'no_update' && typeof state.homepageDonhangsanphamFilter.homepageDonhangsanphamPage !== 'undefined') action.data.homepageDonhangsanphamPage = state.homepageDonhangsanphamFilter.homepageDonhangsanphamPage;
        if (action.data.homepageDonhangsanphamLimit == 'no_update' && typeof state.homepageDonhangsanphamFilter.homepageDonhangsanphamLimit !== 'undefined') action.data.homepageDonhangsanphamLimit = state.homepageDonhangsanphamFilter.homepageDonhangsanphamLimit;
      }
      return {
        ...state,
        homepageDonhangsanphamFilter: action.data,
      }
    }
    case DONHANGSANPHAM_LIST_SUCCESS: {
      return {
        ...state,
        items: action.data.items,
        total: action.data.total,
      }
    }
    case DONHANGSANPHAM_HOMEPAGE_LIST_SUCCESS: {
      return {
        ...state,
        homepageDonhangsanphamItems: action.data.homepageDonhangsanphamItems,
        homepageDonhangsanphamTotal: action.data.homepageDonhangsanphamTotal,
      }
    }
    case DONHANGSANPHAM_ONE_SUCCESS: {
      return {
        ...state,
        selected: action.data
      }
    }
    case DONHANGSANPHAM_HOMEPAGE_ONE_SUCCESS: {
      return {
        ...state,
        homepageDonhangsanphamSelected: action.data
      }
    }
    case DONHANGSANPHAM_LIMIT_UPDATE_HOMEPAGE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.homepageDonhangsanphamLimitFilter !== 'undefined' && state.homepageDonhangsanphamLimitFilter) {
        if (action.data.homepageDonhangsanphamLimitPage == 'no_update' && typeof state.homepageDonhangsanphamLimitFilter.homepageDonhangsanphamLimitPage !== 'undefined') action.data.homepageDonhangsanphamLimitPage = state.homepageDonhangsanphamLimitFilter.homepageDonhangsanphamLimitPage;
        if (action.data.homepageDonhangsanphamLimitLimit == 'no_update' && typeof state.homepageDonhangsanphamLimitFilter.homepageDonhangsanphamLimitLimit !== 'undefined') action.data.homepageDonhangsanphamLimitLimit = state.homepageDonhangsanphamLimitFilter.homepageDonhangsanphamLimitLimit;
      }
      return {
        ...state,
        homepageDonhangsanphamLimitFilter: action.data,
      }
    }
    case DONHANGSANPHAM_LIMIT_HOMEPAGE_LIST_SUCCESS: {
      return {
        ...state,
        homepageDonhangsanphamLimitItems: action.data.homepageDonhangsanphamLimitItems,
        homepageDonhangsanphamLimitTotal: action.data.homepageDonhangsanphamLimitTotal,
      }
    }
    case DONHANGSANPHAM_LIMIT_HOMEPAGE_ONE_SUCCESS: {
      return {
        ...state,
        homepageDonhangsanphamLimitSelected: action.data
      }
    }
    case DONHANGSANPHAM_NEW_CARE_SUCCESS: {
      return {
        ...state,
        newCare: action.data.newCare,
        canCare: action.data.canCare,
      }
    }
    case DONHANGSANPHAM_IMPORT_SUCCESS: {
      return {
        ...state,
        temp: action.data,
      }
    }
    case DONHANGSANPHAM_COUNT_ASSIGN_SUCCESS: {
      return {
        ...state,
        countAssign: action.data,
      }
    }
    case DONHANGSANPHAM_HISTORY_LIST_SUCCESS: {
      return {
        ...state,
        history: action.data.items,
        totalHistory: action.data.total,
      }
    }
    case LOOKUP_CLEANER: {
      return initState
    }
    case DONHANGSANPHAM_SAVE_SUCCESS: {
      return {
        ...state,
        temp_upgoicuoc: []
      }
    }
    case DONHANGSANPHAM_HANDLE_IMPORT_ERRORS: {
      return {
        ...state,
        errorRows: action.data,
      }
    }
    default: {
      return state;
    }
  }
}
export default donhangsanphamReducer